module.exports = __webpack_public_path__ + "img/SKMJ_enter1.f93be0a6.jpg";